
import React, { Component } from 'react';
import * as actions from "../actions";
import * as utils from "../../utils";
import $ from 'jquery';
import $_swipeshow from 'swipeshow';


const Swipeshow = React.createClass({
  componentDidMount() {
    this.activateSwipeshow();
  },
  componentWillUnmount() {
    this.deactivateSwipeshow();
  },
  render() {
    const { photos, slideIndex } = this.props;
    const photoCount = photos.objects.length;
    const needsNavigation = photoCount > 1;
    return (
      <div className="swipeshow">
        <SlideshowSlides photos={photos} />
        { needsNavigation &&
          <SlideshowNavigation />
        }
        <SlideshowCounter slideIndex={slideIndex} photoCount={photoCount} />
      </div>
    )
  },
  activateSwipeshow() {
    const slideIndex = this.props.slideIndex;
    const photos = this.props.photos;
    const photoCount = photos.objects.length;
    $('.swipeshow').swipeshow({
      autostart: false,
      speed: 300,
      initial: slideIndex,
      keys: false,
      onactivate: (current, index, prev, prevIndex) => {
        if (prevIndex !== null) {
          const postId = photos.objects[index].id;
          const showInterstitialAd = photoCount > 3 && !utils.isPremium();
          const isEnd = index === 0 && prevIndex === photoCount - 1;
          const isEndOnMobile = index === photoCount - 1 && index === prevIndex;
          const directionIsNext = index > prevIndex;
          actions.changeSlideshowSlide(postId, directionIsNext);
          // Render the overlay ad if we are coming from last slide to first
          if (showInterstitialAd && (isEnd || isEndOnMobile)) {
            // Delay required for goTo to work from within the onactivate
            if (utils.isMobile()) {
              window.setTimeout(function() {
                $('.swipeshow').swipeshow().goTo(0);
              }, 500);
            }
            actions.setOverlayAdVisible(true);
          }
          /*  This is required since swiping on the gallery swallows the click
              event which is required for things like dismissing drop downs */
          $('.swipeshow').click();
        }
      }
    });
  },
  deactivateSwipeshow() {
    $('.swipeshow').unswipeshow();
  }
});

function SlideshowSlides(props) {
  const objects = props.photos.objects;
  const post_nodes = objects.map((post, i) => {
    return (
      <SlidePhoto imgUrl={post.content.url} key={post.id} />
    );
  });
  return (
    <ul className="slides">
      {post_nodes}
    </ul>
  )
}

function SlidePhoto(props) {
  const w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  const slidePhotoSize = w > 600 ? 1000 : 600;
  const slideStyle = {
    backgroundImage: `url(${props.imgUrl}=s${slidePhotoSize})`
  };
  return (
    <li className="slide">
      <div className="slideshow-photo" style={slideStyle}></div>
    </li>
  );
}

function SlideshowNavigation(props) {
  return (
    <div className="prev-next">
      <a href="#" className="next">
        <span className="icon-arrow-right"></span>
        <span className="prev-next-text">Next</span>
      </a>
      <a href="#" className="previous">
        <span className="icon-arrow-left"></span>
        <span className="prev-next-text">Previous</span>
      </a>
    </div>
  )
}

function SlideshowCounter(props) {
  const { slideIndex, photoCount } = props;
  return (
    <div className="slideshow-counter">
      <i className="icon-arrow-left" />
      <span>
        {slideIndex + 1} of {photoCount}
      </span>
      <i className="icon-arrow-right" />
    </div>
  );
}

export default Swipeshow;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/slideshow/components/swipeshow.es6